import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { ThemeToggleComponent } from './shared/components/theme-toggle/theme-toggle.component';
import { HlmToasterImports } from './shared/components/sonner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ThemeToggleComponent, ...HlmToasterImports],
  template: `
    <hlm-toaster position="bottom-right"></hlm-toaster>
    <router-outlet></router-outlet>
  `,
  styles: [],
})
export class AppComponent {
  title = 'skiss Backoffice';

  constructor(private themeService: ThemeService) {
    // Initialize theme service
  }
}
